import React from "react";
var PriceButton = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: " px-1 pb-1 mx-1 h-8" },
            React.createElement("p", { className: "".concat(props.additionalClass, " font-poppins text-c-purple") }, props.priceTitle + "$"))));
};
export default PriceButton;
